import React from 'react';
import { useParams } from 'react-router-dom';
import { useTenancy } from '@/contexts/TenancyContext';

// Import original PolicyAdmin component
import { PolicyAdmin } from '../../policy-admin';
// Import context provider without UI elements
import AuditorContextProvider from '../components/AuditorContextProvider';

/**
 * Auditor Policy - read-only version of the Policy Admin
 * This component reuses the original PolicyAdmin component with read-only mode
 * We use AuditorContextProvider to get the context providers but avoid duplicate headers
 */
const AuditorPolicyAdmin: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const { activeTenancy } = useTenancy();

  return (
    <AuditorContextProvider>
      <PolicyAdmin 
        isReadOnly={true} 
      />
    </AuditorContextProvider>
  );
};

export default AuditorPolicyAdmin;
